
const useStyles = theme => ({
    root: {
        marginTop: 40,
        justifyContent: 'center',
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            marginTop: 25,
        }
    },
    title: {
        position: 'absolute',
    },
    sectionContainer: {
        marginTop: 10,
        paddingTop: 40,
        paddingBottom: 35,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 35,
            paddingBottom: 25
        }
    }
});

export default useStyles
